/**
 * Logos d'associations actives sur Donoor (dons reçus en prod), tirés de leur
 * fiche et détourés. Affichés avec leurs COULEURS D'ORIGINE (pas de filtre
 * monochrome). Une seule liste pour la bande de logos de l'accueil
 * (SocialProof) et la mosaïque du menu « Choisir Donoor »
 * (AppHeaderMenuChoisir).
 *
 * `small: true` → logo large (format horizontal), affiché plus petit dans la
 * bande pour un poids visuel équilibré avec les logos carrés.
 *
 * Ordre voulu (Karim 2026-10-31) : jamais Al-Houda et Annour côte à côte, ni
 * ASMH (Mosquée Al Houda de Saint-Herblain) à côté de l'une d'elles — la bande
 * tourne en boucle : le dernier logo touche aussi le premier.
 */
export interface LogoAssociation {
  name: string;
  logo: string;
  width: number;
  height: number;
  small?: boolean;
}

export const LOGOS_ASSOCIATIONS: LogoAssociation[] = [
  { name: "ASMH", logo: "/assets/asso/asmh.png", width: 800, height: 849 },
  { name: "Team Élite Pétanque", logo: "/assets/asso/team-elite-petanque.png", width: 400, height: 372 },
  { name: "La Battante", logo: "/assets/asso/la-battante.png", width: 920, height: 359, small: true },
  { name: "Bookin'events", logo: "/assets/asso/bookin-events.png", width: 400, height: 400 },
  { name: "Houda", logo: "/assets/asso/houda.png", width: 800, height: 800 },
  { name: "EquiWay", logo: "/assets/asso/equiway.png", width: 400, height: 298 },
  { name: "MxB Dance", logo: "/assets/asso/blyes-dance.png", width: 484, height: 539 },
  { name: "Grande Masse des Beaux-Arts", logo: "/assets/asso/grande-masse.png", width: 400, height: 372 },
  { name: "Fédération Pêche 95", logo: "/assets/asso/federation-peche.png", width: 204, height: 220 },
  { name: "Annour", logo: "/assets/asso/Annour.png", width: 404, height: 392 },
  { name: "Compagnie IA", logo: "/assets/asso/compagnie-ia.png", width: 131, height: 162 },
  { name: "Damien Joue", logo: "/assets/asso/damien-joue.png", width: 469, height: 237, small: true },
  { name: "L'Espoir de Sainte-Luce", logo: "/assets/asso/espoir-sainte-luce.png", width: 396, height: 400 },
  { name: "Fitra", logo: "/assets/asso/fitra.png", width: 400, height: 335 },
  { name: "Diaspora Saint-Paul", logo: "/assets/asso/diaspora-saint-paul.png", width: 374, height: 400 },
];
